import React, { useEffect } from 'react';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { Spinner, CollapseBlock } from '../../../../common/index.jsx';
import RoomResponsibleTable from './RoomResponsibleTable.jsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useGetRoomResponsiblePersonsQuery,
  useDeleteRoomResponsiblePersonsMutation,
} from '../../../../../redux/services/rooms_responsible.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const RoomResponsiblePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();
  const {
    data: roomsResponsible,
    isLoading,
    refetch,
  } = useGetRoomResponsiblePersonsQuery();
  const [deleteRoomResponsible, { isSuccess: isDeleteSuccess }] =
    useDeleteRoomResponsiblePersonsMutation();

  const pageTitle = t(
    'Zodpovedné osoby pracoviska za schvaľovanie rezervácií miestností',
  );
  useEffect(() => {
    document.title = pageTitle + ' - FRI CMS';
  }, []);

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        //createText={t('Pridať zodpovednú osobu')}
        //createUrl={routes.cmsRoomResponsibleCreate}
        permissionsBasic={'room-responsible'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <RoomResponsibleTable
            roomsResponsible={roomsResponsible}
            onRowClick={(record) =>
              navigate(`${routes.cmsRoomResponsibleEdit}/${record.id}`)
            }
            onCreateClick={() => navigate(`${routes.cmsRoomResponsibleCreate}`)}
            onDelete={(record) => deleteRoomResponsible(record.id)}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default RoomResponsiblePage;
